<template>
	<v-card>
		<v-card-title class="py-2 primary">
			<span class="tertiary--text">
				Riepilogo modifiche precedenti - ID: {{ pratica.custom_id }}
			</span>
		</v-card-title>
		<v-card-text>
			
			<v-row>
				<v-col>
					<template v-for="fase in pratica.ultima_modifica">
						<div class="mt-4 mb-4">
							<div class="font-weight-medium">{{ fase.titolo }}</div>
							<ul>
								<li v-for="campo in fase.campi">
									<span>{{ campo }}</span>
								</li>
								<li v-for="file in fase.files">
									<span>{{ file }}</span>
								</li>
							</ul>
						</div>
					</template>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col>
					<v-radio-group
						v-model="opzioneInvioEmail"
						label="Opzioni di invio"
						:rules="[mixin_rules.radioRequired]"
						class="mt-0"
					>
						<v-radio
							v-for="opzione in opzioniInvioEmail"
							:key="opzione"
							:label="opzione"
							:value="opzione"
						></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>
			
			<v-row v-if="mostraNomeAccountManager" class="mt-0 mb-2">
				<v-col>
					Account Manager che ha messo in coda le modifiche in questa pratica:
					<span class="primary--text font-weight-medium">
						{{ pratica.account_manager_che_ha_messo_in_coda_le_modifiche.nome }}
						{{ pratica.account_manager_che_ha_messo_in_coda_le_modifiche.cognome }}
					</span>
					
				</v-col>
			</v-row>
			
			<v-form ref="modificheInCodaForm">
				<v-row style="width: 500px">
					<v-col>
						<v-checkbox
							v-model="inviaEmailAlCliente"
							label="Inviare email al Cliente?"
							:disabled="checkboxDisabled"
							class="mt-0"
						></v-checkbox>
					</v-col>
					<v-col>
						<v-checkbox
							v-model="inviaEmailAlReferente"
							label="Inviare email al Referente?"
							:disabled="checkboxDisabled"
							class="mt-0"
						></v-checkbox>
					</v-col>
				</v-row>
			</v-form>
			
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				@click="close()"
				:disabled="isSending"
				class="black--text"
			>
				Chiudi
			</v-btn>
			<v-btn
				color="secondary"
				@click="run()"
				:disabled="bottoneInviaDisabled"
				:loading="isSending"
			>
				Invia
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	props: ['value'],
	
	data() {
		return {
			pratica: [],
			opzioniInvioEmail: [
				'Invia email singola di dettaglio',
				'Non inviare email ma metti in coda le modifiche',
				'Invia email multipla di dettaglio svuotando la coda',
				'Invia email multipla di sintesi svuotando la coda'
			],
			opzioneInvioEmail: null,
			inviaEmailAlCliente: false,
			inviaEmailAlReferente: false,
			isSending: false
		}
	},
	
	created() {
		this.pratica = Object.assign([], this.value);
	},
	
	computed: {
		...mapGetters({
			user: 'auth/user',
		}),
		bottoneInviaDisabled() {
			return (
				this.inviaEmailAlReferente === false
					&& this.inviaEmailAlCliente === false
					&& this.opzioneInvioEmail != 'Non inviare email ma metti in coda le modifiche'
				)
				|| this.opzioneInvioEmail === null
		},
		mostraNomeAccountManager() {
			return this.pratica.modifiche_in_coda !== null
				&& (
					this.opzioneInvioEmail == 'Invia email multipla di dettaglio svuotando la coda'
					|| this.opzioneInvioEmail == 'Invia email multipla di sintesi svuotando la coda'
				)
		},
		checkboxDisabled() {
			return this.opzioneInvioEmail === null
				|| this.opzioneInvioEmail == 'Non inviare email ma metti in coda le modifiche'
		}
	},
	
	watch: {
		checkboxDisabled(val) {
			if (val === true) {
				this.inviaEmailAlCliente = false;
				this.inviaEmailAlReferente = false;
			}
		}
	},
	
	methods: {
		run() {
			this.isSending = true;
			
			axios.post('/api/pratiche/gestisci-opzioni-di-invio-email', {
				pratica_id: this.pratica.id,
				account_manager_id: this.user.account_manager.id,
				modifiche: this.pratica.ultima_modifica,
				opzione_invio_email: this.opzioneInvioEmail,
				invia_email_al_cliente: this.inviaEmailAlCliente,
				invia_email_al_referente: this.inviaEmailAlReferente,
			})
				.then(() => {
					this.$emit('azione-eseguita')
				})
				.finally(() => {
					this.isSending = false;
				})
		},
		close() {
			this.$emit('close');
		}
	}
}
</script>